import {Text} from '@dropbox/dig-components/typography';
import {Box} from '@dropbox/dig-foundations';
import {LabelGroup} from 'components/DSYS/LabelGroup';
import {Table} from 'components/DSYS/Table';
import {forwardRef, ReactNode} from 'react';

export const OverflowCell = ({children}: {children: ReactNode}) => {
  return <div style={{textOverflow: 'ellipsis', overflow: 'hidden'}}>{children}</div>;
};

export const LabelGroupCell = forwardRef<
  HTMLTableCellElement,
  {
    isBold?: boolean;
    text: ReactNode;
    fullText?: boolean;
    subText?: ReactNode;
    withLeftAccessory?: ReactNode;
    className?: string;
    columnIndex?: number;
    hasContent?: boolean;
  }
>(
  (
    {isBold, text, subText, withLeftAccessory, className, fullText, columnIndex, hasContent = true},
    ref
  ) => {
    return (
      <Table.Cell ref={ref} columnIndex={columnIndex} hasContent={hasContent}>
        <Box
          padding="4"
          overflow="hidden"
          whiteSpace="nowrap"
          style={{
            // width,
            textOverflow: 'ellipsis',
          }}
          // paddingLeft={paddingLeft}
        >
          <Box paddingY={!className ? '4' : undefined} className={className}>
            <LabelGroup
              align="top"
              withLeftAccessory={withLeftAccessory}
              withText={
                fullText ? (
                  <Text isBold={isBold}>{text}</Text>
                ) : (
                  <Text isBold={isBold}>
                    <div style={{display: 'flex', whiteSpace: 'nowrap'}}>
                      <span style={{textOverflow: 'ellipsis', overflow: 'hidden'}}>{text}</span>
                    </div>
                  </Text>
                )
              }
              withSubtext={
                subText && (
                  <Text color="faint" size="small">
                    <div style={{display: 'flex', whiteSpace: 'nowrap'}}>{subText}</div>
                  </Text>
                )
              }
            />
          </Box>
        </Box>
      </Table.Cell>
    );
  }
);

LabelGroupCell.displayName = 'LabelGroupCell';

export const LabelGroupSubtleCell = forwardRef<
  HTMLTableCellElement,
  {
    text: ReactNode;
    subText?: ReactNode;
    withLeftAccessory?: ReactNode;
    className?: string;
    columnIndex?: number;
    hasContent?: boolean;
    shadowGradientBackgroundColor?: string;
  }
>(
  (
    {
      text,
      subText,
      withLeftAccessory,
      className,
      columnIndex,
      hasContent = true,
      shadowGradientBackgroundColor,
    },
    ref
  ) => {
    return (
      <Table.Cell
        ref={ref}
        columnIndex={columnIndex}
        hasContent={hasContent}
        shadowGradientBackgroundColor={shadowGradientBackgroundColor}
      >
        <Box paddingY={!className ? '4' : undefined} className={className}>
          <LabelGroup
            withLeftAccessory={withLeftAccessory}
            withText={<Text size="small">{text}</Text>}
            withSubtext={
              subText && (
                <Text color="faint" size="xsmall">
                  {subText}
                </Text>
              )
            }
          />
        </Box>
      </Table.Cell>
    );
  }
);

LabelGroupSubtleCell.displayName = 'LabelGroupSubtleCell';
